import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from 'file-saver';
import { baseUrl, getDateWithDay, requirementStatusList } from "../../comman/config";
import { VegRequirementFilter } from "../../components/Filter/VegRequirementFilter.js";
import toast, { Toaster } from "react-hot-toast";
import IngredientBatchModel from "../../components/IngredientBatchModel.js";
import Select from 'react-select';
import Loader from "../../components/Loader.js";
import NoRecordsFound from "../../components/NoRecordsFound.js";
import OrderIngredientModel from "../../components/OrderIngredientModel.js";
import PurchaseDetailModal from "../../components/PurchaseDetailModel.js";
import * as XLSX from 'xlsx';
import { menuAboveTable } from "../../comman/selectMenu";
// import Pagination from "react-js-pagination";

function PurchaseList() {
  const today = new Date().toISOString().split("T")[0];
  const [ingredientPurchaseList, setIngredientPurchaseList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [ingredient, setIngredient] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [purchaseStatus, setPurchaseState] = useState({value: 1, label: "Pending Purchase"});
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [orderIngedientList, setOrderIngredientList] = useState(null);
  const [itemOrderList, setItemOrderList] = useState(null);
  const [methodList, setMethodList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [selectedPurchaseItem, setSelectedPurchaseItem] = useState(null);
  const [selectedDate, setSelectedDate] = useState(today);

  useEffect(() => {
    getMethodList()
  }, []);
useEffect(() => {
  getIngredientPurchaseList();
}, [fromDate, toDate, ingredient, purchaseStatus])

useEffect(()=>{
  console.log(ingredientPurchaseList)
  getIngredientList()
},[ingredientPurchaseList])

  const handelFilterChange = async (from_date, to_date, session, item, requirement_status,order_status, order_id, purchase_status, receipt_status, issue_status, ingredient) => {
    
        setFromDate(from_date);
        setToDate(to_date);
        setIngredient(ingredient); 
       setPurchaseState(purchase_status);
      //  setSelectedDate(today);
  };

  const getMethodList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=method_master&condition=status=1`
    );
    setMethodList(response.data.data);
  };
  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = ingredientPurchaseList.map(item => item.ingredient_id);
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 3 && !existingIngredientIds.includes(item.id));
    setIngredientList(list);
  };
  const getIngredientPurchaseList = async() => {
    setLoading(true)
    setNoRecordsFound(false)
    const response = await axios.post(`${baseUrl}/purchase/list`,
      { from_date : fromDate,
        to_date :toDate,
        ingredient : ingredient?.value,
        purchase_status : purchaseStatus?.value,
        date: selectedDate
       
    });
    const updatedArray = response?.data?.data.map(item => ({
      ...item,         // Spread existing properties
      purchase_qty: item.purchase_qty ?? "", 
      pur_pack_nos: item?.pur_pack_nos ?? 0,        // Add new key-value pair
      diff_qty : item.purchase_qty - item.total_order ?? 0
  }));
    setIngredientPurchaseList(updatedArray);
    setNoRecordsFound(updatedArray.length === 0);
    setLoading(false)
  }

  
  const handleSubmit = async() => {
    if(selectedRows.length == 0){
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }
    console.log(selectedRows);
    if(selectedRows.some(item => item.purchase_qty === "")){
      alert("One or more items have an empty purchase qty value.");
      setSelectedRows([]);
      return;
    }
    if(selectedRows.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([])
      return
    }
    if(selectedRows.length > 0){
        try{
          if(window.confirm(`આ શાકભાજી "પરચેઝ" થવા જઈ રહી છે. હવે પછી "પરચેઝ" માં કોઈ સુધારો થઇ શકશે નહી .
            કોઈ કારણસર કોઈ સુધારો કરવાનો થાય તો "શાકભાજી પરચેઝ (ખરીદ) ટીમ" ને જાણ કરવી.
            શું તમે "પરચેઝ" કરવા માંગો છો ?`))
          {
            const response = await axios.post(`${baseUrl}/purchase/ingredient_purchase`,
              { ingredientsList : selectedRows,
                date: selectedDate
                });
                const msg = response.data.msg;
                toast.success(msg);
                getIngredientPurchaseList();
          }
        }catch (error) {
            toast.error("Failed to add item. Please try again.");
        }
    }
    setSelectedRows([])
  };

  const handleSave = async() => {
    if(selectedRows.length == 0){
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }
    console.log(selectedRows);
    if(selectedRows.some(item => item.purchase_qty === "")){
      alert("One or more items have an empty purchase qty value.");
      setSelectedRows([]);
      return;
    }
    if(selectedRows.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([])
      return
    }
    if(selectedRows.length > 0){
      try{
        const response = await axios.post(`${baseUrl}/purchase/ingredient_save`,
          { 
            ingredientsList : selectedRows
          });
          toast.success("Data save sucessfully.");
          getIngredientPurchaseList();
      }catch (error) {
        toast.error("Failed to add item. Please try again.");
      }
    }
    setSelectedRows([])
  }

const handleExport = async (e) => {
  e.preventDefault();
  try {
    const headerRow = ["Ingredient", "Total Order Qty", "Total Purchase Qty", "Diff Qty", "Rate (AVG)","Total Value (RS)","Pur Pack Nos", "Purchase Status", "Purchase Id"];

    const data = ingredientPurchaseList.map(item => {
      const status = item.purchase_status == 1 || item.purchase_status == 2 ? "Pending Purchase" : "Purchased";
      return {
        "Ingredient": item.ingredient,
        "Total Order Qty": item.total_order,
        "Total Purchase Qty": item?.purchase_qty ?? '',
        "Diff Qty": item.diff_qty,
        "Rate (AVG)": item.rate,
        "Total Value (RS)": item.total_value,
        "Pur Pack Nos": item?.pur_pack_nos ?? 0,
        "Purchase Status": status,
        "Purchase Id": item.purchase_id,
      };
    });

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headerRow });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'PurchaseData');

    // Write the workbook as a binary array
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Create a Blob from the binary array
    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Create a download link manually
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'purchase.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
  } catch (error) {
    toast.error("Failed to export item. Please try again.");
  }
};


  const handleAddNewIngredientRow = () => {
    setIngredientPurchaseList([...ingredientPurchaseList, {
      ingredient: '',
      ingredient_obj:{},
      ingredient_id: null,
      total_order: 0,
      purchase_qty: '',
      pur_pack_nos: '',
      diff_qty: 0,
      purchase_status: 1,
      isNew: true
    }]);
  };

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setIngredientPurchaseList((prevFormData) => {
      if(name === "pur_pack_nos"){
        const updatedFormData = [...prevFormData];
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
        return updatedFormData;
      }else{
        const updatedFormData = [...prevFormData];
        const total_order = updatedFormData[index].total_order;
        const diff_qty = (value - total_order).toFixed(2);
           updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_qty : diff_qty };
         return updatedFormData;
      }
    });
  };

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(ingredientPurchaseList[index])
        ? selectedRows.filter(item => item !== ingredientPurchaseList[index]) // Deselect
        : [...selectedRows, ingredientPurchaseList[index]]; // Select

   setSelectedRows(updatedSelectedRows);
    

};
const handleSwitchSelectAll = () => {
  if (selectAll) {
      setSelectedRows([]);
  } else {
      setSelectedRows(ingredientPurchaseList.filter((item) => item.purchase_status == 1)); // Select all rows
  }
  setSelectAll(!selectAll);
};

  const displayIngredientDetail = async(e, item) => {
    e.preventDefault();
    setLoading(true)
    let condition = `ingredient_id = '${item.ingredient_id}' AND order_status = 3 AND date= '${selectedDate}'`;
    // if(fromDate == toDate){
    //   condition += ` AND date = '${fromDate}' `;
    // }else if(fromDate && toDate){

    //   condition += ` AND (date >= '${fromDate}' AND  date  <= '${toDate}') `;
    // }
    
    const response = await axios.get(
        `${baseUrl}/comman/list?table=item_requirement_summary&condition=${condition}`
    );
    const orderList = response.data.data;

    const ingredientRes = await axios.get(
      `${baseUrl}/comman/list?table=ingredients_master&condition=id='${item.ingredient_id}'`
    );
    const ingredientName = ingredientRes.data.data[0]?.ingredient || '';

    const orderWithName = orderList.map((row) => ({
      ...row,
      ingredient: ingredientName,
    }));
    setItemOrderList(orderWithName);
    setLoading(false)
    setShowModal(true);
  }

const fetchPurchaseSequences = async (itemId) => {
  try {
    // Get purchase sequences for this ingredient
    const sequencesResponse = await axios.get(
      `${baseUrl}/comman/list?table=purchase_sequences&condition=item_requirement_id='${itemId}'`
    );
    
    return sequencesResponse.data.data || [];
  } catch (error) {
    console.error("Error fetching purchase sequences:", error);
    return [];
  }
};

// Example updated function for displaying purchase sequence details
const displayPurchaseSequenceDetail = async (e, item) => {
  e.preventDefault();
  setLoading(true);
  
  try {
    // Get purchase sequences for this ingredient
    const sequences = await fetchPurchaseSequences(item.id);
    
    // Get ingredient details
    const ingredientRes = await axios.get(
      `${baseUrl}/comman/list?table=ingredients_master&condition=id='${item.ingredient_id}'`
    );
    const ingredientName = ingredientRes.data.data[0]?.ingredient || '';
    
    // Set sequence data
    let packDetails = [];
    
    // If there are existing sequences, use them
    if (sequences && sequences.length > 0) {
      packDetails = sequences.map(seq => ({
        pack: seq.sequence_number,
        purchaseQty: parseFloat(seq.quantity),
        rate: parseFloat(seq.rate),
        value: parseFloat(seq.value)
      }));
    } else {
      // If no sequences exist but there's a purchase_qty, create a default sequence
      if (item.purchase_qty > 0) {
        packDetails = [{
          pack: parseFloat(item.sequence_number),
          purchaseQty: parseFloat(item.purchase_qty),
          rate: parseFloat(item.avg_rate || 0),
          value: parseFloat(item.total_value || 0)
        }];
      } else {
        // Default empty row
        packDetails = [{ 
          pack: 0, 
          purchaseQty: 0, 
          rate: 0, 
          value: 0 
        }];
      }
    }
    
    // Prepare the item with complete information for the modal
    const itemWithDetails = {
      ...item,
      ingredient: ingredientName,
      packDetails: packDetails
    };
    
    // Set the selected item for the modal
    setSelectedPurchaseItem(itemWithDetails);
    setLoading(false);
    setShowPurchaseModal(true);
  } catch (error) {
    console.error("Error fetching purchase sequence details:", error);
    toast.error("Failed to fetch purchase details");
    setLoading(false);
  }
};

const handlePurchaseDetailSave = async (updatedItem) => {
  try {
    // Update the main list with values from the modal
    const updatedList = ingredientPurchaseList.map(item => {
      if (item.id === updatedItem.id) {
        // Update the main item with values from the modal
        return {
          ...item,
          purchase_qty: updatedItem.purchase_qty,
          avg_rate: updatedItem.avg_rate,
          total_value: updatedItem.total_value,
          pur_pack_nos: updatedItem.pur_pack_nos,
          diff_qty: updatedItem.purchase_qty - item.total_order  
        };
      }
      return item;
    });
    
    // Update state
    setIngredientPurchaseList(updatedList);
    
    // Close the modal
    setShowPurchaseModal(false);
    
    // Show success message
    toast.success("Purchase details saved successfully");
  } catch (error) {
    console.error("Error updating purchase details:", error);
    toast.error("Failed to update purchase details");
  }
};

  const clearItem = () => {
    setSelectedRows([]);
    setItemOrderList(null);
    setOrderIngredientList(null);
    getIngredientPurchaseList();
  };

  const handleNewIngredientChange = (selectedOptions,index) => {
    // setNewIngredient((prev)=>({...prev,ingredient:ingredient}))
    console.log(selectedOptions)
    const updatedList =   [...ingredientPurchaseList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    setIngredientPurchaseList(updatedList)
  }

  return (
    <div className="p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Purchase
        </h1>

        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <div className="flex items-center gap-4 p-2 bg-white">
          <label className="font-medium">પરચેઝ તારીખ :</label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="px-3 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <VegRequirementFilter handleFilterChange={handelFilterChange} page="purchase" />
      </div>
      {noRecordsFound && <NoRecordsFound />}

      {ingredientPurchaseList.length > 0 && (
        <>
          {/* Desktop Table View */}
          <div className="hidden lg:block overflow-visible">
            <table className="w-full mt-10 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-2 py-1 border border-black text-center "><input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} /></th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">શાકભાજી</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">ઓર્ડર વજન</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">લેવાયેલ વજન</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">ફરક વજન</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">રેટ/કિલો (એવરેજ)</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">પેમેન્ટ (₹)</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">દાગીના</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">સ્ટેટસ</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">ID</th>
                </tr>
              </thead>
              <tbody>
                {ingredientPurchaseList.map((item, index) => (
                  <tr key={index} className="border border-black-b">
                    {!(item.purchase_status == 3 && item.receipt_status == 3) && <td className="px-2 py-1 border border-black text-center"><input type="checkbox" checked={selectedRows.includes(item)} onChange={() => handleToggleSelect(index)} /></td>}
                    {(item.purchase_status == 3 && item.receipt_status == 3) && <td className="px-2 py-1 border border-black text-center"></td>}
                    <td className="px-2 py-1 border border-black text-center">
                      {item.isNew ? (
                        <Select
                          {...menuAboveTable}
                          classNamePrefix="select"
                          className='basic-multi-select'
                          value={item.ingredient_obj}
                          name="ingredient"
                          onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                          options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            unit: item.unit?.id,
                            ingredient: `${item.ingredient}`,
                            eng_name: item.eng_name,
                          }))}
                          placeholder="Ingredient List"
                          filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                          }}
                        />
                      ) : (item.ingredient)}
                    </td>
                    <td className="px-2 py-1 border border-black text-center"><a href="#" className="underline text-blue-500" onClick={(e) => displayIngredientDetail(e, item)}>{item.total_order}</a></td>
                    <td className="px-2 py-1 border border-black text-center">
                      <a href="#" className="underline text-blue-500" onClick={(e) => displayPurchaseSequenceDetail(e, item)}>
                        {item?.purchase_qty ? parseFloat(item.purchase_qty).toFixed(2) : '0.00'}
                      </a>
                    </td>
                    <td className={`px-2 py-1 border border-black text-center ${item.diff_qty < 0 ? 'bg-yellow-300 text-black' : ''}`}>{item?.diff_qty ? parseFloat(item.diff_qty).toFixed(2) : '0.00'}</td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item?.avg_rate ? parseFloat(item.avg_rate).toFixed(2) : '0.00'}
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item?.total_value ? parseFloat(item.total_value).toFixed(2) : '0.00'}
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item?.pur_pack_nos ? parseFloat(item.pur_pack_nos).toFixed(2) : '0.00'}
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item.purchase_status == 1 ? "Pending Purchase" : (item.purchase_status == 2 ? "Pending Purchase" : "Purchased")}
                    </td>
                    <td className="px-2 py-1 border border-black text-center">{item.purchase_id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="block lg:hidden mt-4">
            {/* Select All for Mobile */}
            <div className="mb-4 p-3 bg-gray-50 rounded-lg">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="mr-2"
                  onChange={handleSwitchSelectAll}
                  checked={selectAll}
                />
                <span className="text-sm font-medium">Select All</span>
              </label>
            </div>

            {ingredientPurchaseList.map((item, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 mb-4 shadow-sm">
                {/* Header with checkbox and ingredient name */}
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center">
                    {!(item.purchase_status == 3 && item.receipt_status == 3) && (
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(item)}
                        onChange={() => handleToggleSelect(index)}
                        className="mr-3 mt-1"
                      />
                    )}
                    <div className="flex-1">
                      <div className="font-medium text-gray-900 text-sm">
                        {item.isNew ? (
                          <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            className='basic-multi-select text-xs'
                            value={item.ingredient_obj}
                            name="ingredient"
                            onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                            options={ingredientList.map((item) => ({
                              value: item.id,
                              label: `${item.ingredient} (${item.eng_name})`,
                              unit: item.unit?.id,
                              ingredient: `${item.ingredient}`,
                              eng_name: item.eng_name,
                            }))}
                            placeholder="Ingredient List"
                            filterOption={(option, inputValue) => {
                              return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                          />
                        ) : (
                          item.ingredient
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <span className={`inline-block px-2 py-1 rounded-full text-xs ${item.purchase_status == 1 ? 'bg-yellow-100 text-yellow-800' :
                        item.purchase_status == 2 ? 'bg-yellow-100 text-yellow-800' :
                          'bg-green-100 text-green-800'
                      }`}>
                      {item.purchase_status == 1 ? "Pending" : (item.purchase_status == 2 ? "Pending" : "Purchased")}
                    </span>
                  </div>
                </div>

                {/* Details Grid */}
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <label className="text-gray-600 text-xs">ઓર્ડર વજન</label>
                    <div className="font-medium">
                      <a href="#" className="underline text-blue-500" onClick={(e) => displayIngredientDetail(e, item)}>
                        {item.total_order}
                      </a>
                    </div>
                  </div>

                  <div>
                    <label className="text-gray-600 text-xs">લેવાયેલ વજન</label>
                    <div className="font-medium">
                      <a href="#" className="underline text-blue-500" onClick={(e) => displayPurchaseSequenceDetail(e, item)}>
                        {item?.purchase_qty ? parseFloat(item.purchase_qty).toFixed(2) : '0.00'}
                      </a>
                    </div>
                  </div>

                  <div>
                    <label className="text-gray-600 text-xs">ફરક વજન</label>
                    <div className={`font-medium ${item.diff_qty < 0 ? 'text-yellow-600 bg-yellow-100 px-1 rounded' : ''}`}>
                      {item?.diff_qty ? parseFloat(item.diff_qty).toFixed(2) : '0.00'}
                    </div>
                  </div>

                  <div>
                    <label className="text-gray-600 text-xs">રેટ/કિલો (એવરેજ)</label>
                    <div className="font-medium">
                      {item?.avg_rate ? parseFloat(item.avg_rate).toFixed(2) : '0.00'}
                    </div>
                  </div>

                  <div>
                    <label className="text-gray-600 text-xs">પેમેન્ટ (₹)</label>
                    <div className="font-medium">
                      {item?.total_value ? parseFloat(item.total_value).toFixed(2) : '0.00'}
                    </div>
                  </div>

                  <div>
                    <label className="text-gray-600 text-xs">દાગીના</label>
                    <div className="font-medium">
                      {item?.pur_pack_nos ? parseFloat(item.pur_pack_nos).toFixed(2) : '0.00'}
                    </div>
                  </div>
                </div>

                {/* Purchase ID */}
                <div className="mt-3 pt-2 border-t border-gray-100">
                  <div className="text-xs text-gray-500">
                    ID: <span className="font-medium">{item.purchase_id}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      <IngredientBatchModel showModal={showModal} setShowModal={setShowModal} detailList={itemOrderList} clearItem={clearItem} type={2} />
      <PurchaseDetailModal
        showModal={showPurchaseModal}
        setShowModal={setShowPurchaseModal}
        selectedItem={selectedPurchaseItem}
        onSave={handlePurchaseDetailSave}
        onClose={() => setShowPurchaseModal(false)}
      />

      {ingredientPurchaseList.length > 0 && (
        <div className='m-5'>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={handleSave}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
            >
              Save
            </button>
            <button
              onClick={handleAddNewIngredientRow}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
            >
              Add Ingredient
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-rose-400 text-white rounded-md hover:bg-rose-300 focus:outline-none focus:ring focus:ring-rose-300"
            >
              Purchase
            </button>
            <button
              onClick={handleExport}
              className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200"
            >
              Export
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PurchaseList;
